import { defineMessages } from 'react-intl';

export default defineMessages({
    policyNumber: {
        id: 'quoteandbind.views.canceled-policy.Policy Number',
        defaultMessage: 'Policy Number',
    },  
    canceledReason: {
        id: 'quoteandbind.views.canceled-policy.Cancel Reason',
        defaultMessage: 'Cancel Reason',
    },
    cancellationDate: {
        id: 'quoteandbind.views.canceled-policy.Cancellation Date',
        defaultMessage: 'Cancellation Date',
    },
    canceledPolicyForThisHome: {
        id: 'quoteandbind.views.canceled-policy.Canceled Policy for This Home',
        defaultMessage: 'Canceled Policy for This Home'
    },
    sourceSystem: {
        id: 'quoteandbind.views.canceled-policy.Source System',
        defaultMessage: 'Source System'
    },
    description: {
        id: 'quoteandbind.views.canceled-policy.Description',
        defaultMessage: 'Description'
    },
    description: {
        id: 'quoteandbind.views.canceled-policy.Add',
        defaultMessage: 'Add'
    },
    cancelledPolicy: {
        id: 'quoteandbind.views.canceled-policy.Cancelled Policy',
        defaultMessage: 'Cancelled Policy:'
    },
    
});
